import React from 'react';
import PropTypes from 'prop-types';

import Title from '../shared/Title';
import OnOffTable from './Table/OnOffTable';
import NoData from '../shared/NoData';
import Spinner from '../shared/Spinner';
import { MultiSelect } from '../shared/MultiSelect';
import { createOverflow } from '../../lib/format';
import ItemSelector from '../shared/ItemSelector';

const OnOffMetrics = ({
  team,
  pathTo,
  gameSelector,
  players,
  season,
  onSortChange,
  sortKey,
  games,
  onGameChange,
  division,
  conference,
  isNBA,
}) => {
  const isLoading = !players;
  const hasPlayers = !isLoading && players.length;
  const overflow = createOverflow(team, season);

  return (
    <div className="s-onoff">
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle={'OnOff Metrics'}
        overflow={overflow}
      />

      <div className="filter">
        <div className="form-row">
          <div className="form-column--xs">
            <MultiSelect
              className="s-advanced-stats__multi-game-selector"
              empty="Select game(s) to filter by..."
              items={
                games &&
                games.map(mapped => ({ value: mapped.id, label: mapped.name }))
              }
              onChange={onGameChange}
              isSearchable={true}
              isLoading={!games}
              wrapperClassname={
                's-advanced-stats__multi-game-selector--wrapper'
              }
              loadingMessage={'Loading games...'}
              classNamePrefix="react-select"
            />
          </div>
          <div className="form-column--xs">
            <div className="form-group">
              <label>Division</label>
              <ItemSelector {...division} disabled={isNBA} />
            </div>
          </div>
          <div className="form-column--xs">
            <div className="form-group">
              <label>Conference</label>
              <ItemSelector {...conference} />
            </div>
          </div>
        </div>
      </div>

      {hasPlayers ? (
        <OnOffTable
          players={players}
          onSortChange={onSortChange}
          sortKey={sortKey}
        />
      ) : isLoading ? (
        <Spinner />
      ) : (
        <NoData />
      )}
    </div>
  );
};

OnOffMetrics.propTypes = {
  team: PropTypes.object,
  gameSelector: PropTypes.object,
  players: PropTypes.array,
  pathTo: PropTypes.func.isRequired,
};

export default OnOffMetrics;
